<div [formGroup]="form">
  <kendo-datepicker [format]="'dd-MMM-yyyy'"
                    [placeholder]="field.placeholderText!"
                    [id]="field.controlName"
                     [min]="minDate"
    [max]="maxDate"
                    [formControlName]="field.controlName" date-picker-input-clear-button (valueChange)="onDateChange($event)">
  </kendo-datepicker>
</div>
